<div class="data-table-container">
  <div class="data-table-wrapper">
    @if (!hidden) {
    <table mat-table [dataSource]="dataSource" multiTemplateDataRows aria-describedby="data-table-container">
      <!-- Cells -->
      @for (column of columns; track column; let ix = $index) {
      <ng-container [matColumnDef]="column.name" [sticky]="ix < 3">
        <th mat-header-cell [ngStyle]="getDynamicFlexStylingFor(ix)" *matHeaderCellDef>
          {{ column.text | translate }}
        </th>
        <td mat-cell [ngStyle]="getDynamicFlexStylingFor(ix)" *matCellDef="let rowGroup">
          <ng-container
            *ngTemplateOutlet="
              cellContent;
              context: {
                row: rowGroup.row,
                column: column,
                index: ix,
                expanded: isExpandedRowGroup(rowGroup)
              }
            "
          ></ng-container>
        </td>
      </ng-container>
      }
      <!-- Expanded content -->
      <ng-container matColumnDef="expandedRows">
        <td mat-cell *matCellDef="let expansionContent" [attr.colspan]="displayedColumns.length">
          <div class="expansion-content">
            @if (!hidden && isExpandedContent(expansionContent)) {
            <table mat-table [dataSource]="expansionContent.rows" aria-describedby="expansion-content">
              <!-- Expanded content - cells -->
              @for (column of columns; track column; let ix = $index) {
              <ng-container [matColumnDef]="column.name" [sticky]="ix < 3">
                <th mat-header-cell *matHeaderCellDef class="display-none">{{ column.text | translate }}</th>
                <td mat-cell [ngStyle]="getDynamicFlexStylingFor(ix)" *matCellDef="let row">
                  <ng-container
                    *ngTemplateOutlet="cellContent; context: { row: row, column: column, index: ix, hideArrow: true }"
                  ></ng-container>
                </td>
              </ng-container>
              }
              <!-- Expanded content - rows -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns" class="display-none"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            }
          </div>
        </td>
      </ng-container>
      <!-- Rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let rowGroup; columns: displayedColumns; when: isExpandableRowGroup"
        class="expandable-row-group"
        [class.expanded-row-group]="isExpandedRowGroup(rowGroup)"
        (click)="rowGroup.expansionContent.expanded = !rowGroup.expansionContent.expanded"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedRows']; when: isExpansionContentRow" class="expansion-content-wrapper"></tr>
    </table>
    }
  </div>

  <!-- Cell -->
  <ng-template #cellContent let-row="row" let-ix="index" let-column="column" let-expanded="expanded" let-hideArrow="hideArrow">
    @if (row?.hasOwnProperty(column.name)) {
    <div class="flex-row-container wrap text-wrap">
      @if (!row[column.name]?.hasOwnProperty('actionIcons')) {
      <div class="flex-row-container">
        @if (ix === 1) {
        <mat-icon [class.visibility-hidden]="hideArrow">{{ expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
        }
        <div class="flex-shrink">
          {{ row[column.name] | translate }}
        </div>
      </div>
      } @else {
      <div class="flex-row-container">
        @if (row[column.name].label) {
        <div class="flex-80-px">
          {{ row[column.name].label | translate }}
        </div>
        }
        <div class="flex-10-px"></div>
        @if (row[column.name].actionIcons?.length > 0) {
        <div class="flex-40 flex-row-container gap-10">
          @for (icon of row[column.name].actionIcons; track icon) {
          <div class="flex-20-px">
            <mat-icon
              class="action-icon"
              svgIcon="{{ icon.customIcon ? icon.customIcon : '' }}"
              [matTooltip]="icon.iconTooltip | translate"
              [matTooltipClass]="'tooltip'"
              (click)="$event.stopPropagation(); icon.action(row)"
              >{{ icon.matIcon ? icon.matIcon : '' }}</mat-icon
            >
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
    }
  </ng-template>
</div>
